<template>
  <v-container class="bg-section mb-16" fluid>
    <v-row class="justify-center align-center mb-14">
      <v-col cols="3" xs="0" sm="0" md="0" lg="3" class="hidden-md-and-down">
        <v-img
          :src="require('@/assets/icons/btn-play.svg')"
          contain
          class="play"
          height="80"
        />
        <v-img
          :src="require('@/assets/consultants/img-video.png')"
          contain
          class="mt-8 back"
          height="400"
        />
      </v-col>
      <v-col cols="1"  class="hidden-md-and-down"></v-col>
      <v-col cols="10" xs="10" sm="10" md="7" lg="5" class="">
        <div class="mb-14">
          <h6>IMPLANTA UN MODELO COLABORATIVO</h6>
          <h2 class="mb-6">Trabaja con tus clientes en tiempo real</h2>
          <p class="">
            Gestiona tu negocio según las necesidades de hoy en día.
          </p>
          <v-row class="align-right mt-6">
            
            <v-col cols="12" xs="12" sm="12" md="6">
              <v-row>
                <v-col cols="4">
                  <v-img
                    :src="require('@/assets/icons/ic.png')"
                    contain
                    height="80"
                  />
                </v-col>
                <v-col cols="8">
                  <h5>Relación con clientes</h5>
                  <p style="font-size: 12px">
                    Facilita el trabajo de tus clientes con esta herramienta.
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-img
                    :src="require('@/assets/icons/icl.png')"
                    contain
                    height="80"
                  />
                </v-col>
                <v-col cols="8">
                  <h5>Almacenamiento</h5>
                  <p style="font-size: 12px">
                    Almacena toda la documentación en la nube.
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6">
              <v-row>
                <v-col cols="4">
                  <v-img
                    :src="require('@/assets/icons/icv.png')"
                    contain
                    height="80"
                  />
                </v-col>
                <v-col cols="8">
                  <h5>Cuentas bancarias</h5>
                  <p style="font-size: 12px">
                    Conecta sus cuentas bancarias de forma segura e inmediata.
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-img
                    :src="require('@/assets/icons/iud.png')"
                    contain
                    height="80"
                  />
                </v-col>
                <v-col cols="8">
                  <h5>Unificación de datos</h5>
                  <p style="font-size: 12px">
                    Unifica toda su información en una única plataforma.
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <!-- End Block -->
    <hr class="mt-20 mb-20" />
  </v-container>
</template>

<script>
export default {
  name: "Work",

  data: () => ({}),
};
</script>

<style scoped>
.play {
  position: absolute;
  z-index: 1;
  margin-top: 200px;
  margin-left: 5%;
}
</style>
